import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { EmailOutlined } from "@material-ui/icons";
import { DraftsOutlined } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import styled from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  displayAlertifySuccess,
  displayAlertifyError,
} from "../../util/functions";

const formList = [
  {
    id: 1,
    content: "California Preliminary 20-Day Notice",
    type: "form1",
  },
  {
    id: 2,
    content: "Conditional Waiver And Release On Final Payment",
    type: "form2",
  },
  {
    id: 3,
    content: "Conditional Waiver And Release On Progress Payment",
    type: "form3",
  },
  {
    id: 4,
    content: "Unconditional Waiver And Release On Final Payment",
    type: "form4",
  },
  {
    id: 5,
    content: "Unconditional Waiver And Release On Progress Payment",
    type: "form5",
  }
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#FC3538",
    },
    input: {
      display: "none",
    },
  })
);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props: ListItemProps<"a", { button?: true }>) {
  return <ListItem button component="a" {...props} />;
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const SendContractForm = () => {
  const classes = useStyles();
  // local storage

  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  // states

  const [selectedItem, setSelectedItem] = useState({});
  const [selectedItemData, setSelectedItemData] = useState({});

  // effects

  useEffect(() => {
    getItems(selectedItem.type);
  }, [selectedItem]);

  //handlers

  const handleSelectClick = (item) => setSelectedItem(item);

  // functions
  const getItems = (type) => {
    let params = { form_type: type };
    axios
      .post(APIModel.HOST + "send-client-forms", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + get_token,
        },
      })
      .then((res) => {
        if (res.data?.status && !Object.keys(res.data?.data)?.length) {
          displayAlertifyError({ error: "No data found" });
        }
        setSelectedItemData(res.data);
      });
  };

  const handleDeleteForm = (item) => {
    axios
      .get(APIModel.HOST + `delete-form/${item.form_no}/${selectedItem.type}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + get_token,
        },
      })
      .then((res) => {
        if (res?.data?.status) {
          displayAlertifySuccess({ message: "Form deleted successfully" });
          getItems(selectedItem.type);
        }
      })
      .catch((error) => {
        displayAlertifyError({ error });
      });
  };

  if (get_token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <DivContarctForm>
                  <div className="heading">
                    <h3 className="font-weight-bold my-0">Lien Form data</h3>
                  </div>
                  <DivContarctFormList>
                    <div className="form-list">
                      {formList.map((item) => (
                        <>
                          <Button
                            fullWidth
                            variant={`${
                              item.id !== selectedItem.id
                                ? "standard"
                                : "contained"
                            }`}
                            style={{
                              color: `${
                                item.id !== selectedItem.id
                                  ? "#FC3538"
                                  : "white"
                              }`,
                              backgroundColor: `${
                                item.id === selectedItem.id
                                  ? "#FC3538"
                                  : "white"
                              }`,
                            }}
                            onClick={() => {
                              handleSelectClick(item);
                            }}
                            key={item.id}
                          >
                            {item.content}
                          </Button>
                          <br />
                        </>
                      ))}
                    </div>
                    <div className="form-data">
                      {selectedItemData.data !== undefined ? (
                        <TableContainer>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Form No</TableCell>
                                <TableCell>State</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>URL</TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            {selectedItemData.data !== [] ? (
                              <TableBody>
                                {Object.keys(selectedItemData.data).map(
                                  (email, index) => (
                                    <React.Fragment>
                                      <Typography
                                        style={{ color: "#FC3538" }}
                                        variant="h6"
                                        className="float-left"
                                      >
                                        {email}
                                        <Divider
                                          classes={{ root: classes.divider }}
                                          className="mt-3"
                                        />
                                      </Typography>
                                      {selectedItemData.data[email].map(
                                        (item, key) => (
                                          <TableRow key={item.id}>
                                            <TableCell className="table-api-url">
                                              <b>{item.form_no}</b>
                                              {item.notification_status == 1 ? (
                                              
                                              <DraftsOutlined
                                              style={{
                                                position: "relative",
                                                top: "5px",
                                                left: "5px",
                                              }}
                                              htmlColor="#FC3538"
                                              fontSize="small"
                                            />
                                                 ) : (
                                                  <EmailOutlined
                                               style={{
                                                 position: "relative",
                                                 top: "5px",
                                                 left: "5px",
                                               }}
                                               htmlColor="#FC3538"
                                               fontSize="small"
                                             />
                                                  )}
                                            </TableCell>
                                            <TableCell className="table-api-url">
                                              <b>{item.form_state}</b>
                                            </TableCell>
                                            <TableCell className="table-api-url">
                                              <b>{item.email}</b>
                                            </TableCell>
                                            <TableCell className="table-api-url">
                                              <caption>{`${APIModel.URL}get-send-${selectedItem.type}/${item.form_no}`}</caption>
                                            </TableCell>
                                            <TableCell>
                                           
                                              <a
                                                href={`${APIModel.URL}get-send-${selectedItem.type}/${item.form_no}`}
                                                target="_blank"
                                                className="mr-2"
                                              >
                                                <Button
                                                  color="primary"
                                                  variant="contained"
                                                  style={{
                                                    backgroundColor: "#9c27b0",
                                                  }}
                                                >
                                                  Preview
                                                </Button>
                                              </a>
                                              <a
                                                href={`${APIModel.URL}edit-${selectedItem.type}/${item.form_no}`}
                                                target="_blank"
                                              >
                                                <Button
                                                  color="primary"
                                                  variant="contained"
                                                  className="mr-2"
                                                  style={{
                                                    backgroundColor: "#9c27b0",
                                                  }}
                                                >
                                                  Edit
                                                </Button>
                                              </a>

                                              <Button
                                                color="primary"
                                                variant="contained"
                                                className="mr-2"
                                                style={{
                                                  backgroundColor: "#9c27b0",
                                                }}
                                                onClick={() =>
                                                  handleDeleteForm(item)
                                                }
                                              >
                                                <DeleteIcon />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </React.Fragment>
                                  )
                                )}
                              </TableBody>
                            ) : (
                              <h3 className="no-data">No Data</h3>
                            )}
                          </Table>
                        </TableContainer>
                      ) : (
                        <h2>Not Found</h2>
                      )}
                    </div>
                  </DivContarctFormList>
                </DivContarctForm>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
};

const DivContarctForm = styled.div`
  .heading {
    background-color: white;
    padding: 14px;
    margin-bottom: 15px;
    border-radius: 6px;
  }
`;

const DivContarctFormList = styled.div`
  .form-list {
    background-color: white;
    padding: 15px 10px 15px 10px;
    display: inline-block;
    margin-bottom: 15px;
    width: 100%;
  }
  button {
    text-transform: capitalize;
    border-bottom: 1px solid #eee;
  }
  button:active {
    border: 1px solid #9c27b0;
  }
  .form-data {
    background-color: white;
    padding: 15px 10px 5px 10px;
    border-radius: 6px;
    .no-data {
      text-align: left;
      font-weight: bold;
    }
  }
`;

export default SendContractForm;
